import { render } from "./Dialog-elevation.vue?vue&type=template&id=117396d5&scoped=true"
import script from "./Dialog-elevation.vue?vue&type=script&lang=js"
export * from "./Dialog-elevation.vue?vue&type=script&lang=js"

import "./Dialog-elevation.vue?vue&type=style&index=0&id=117396d5&lang=css"
import "./Dialog-elevation.vue?vue&type=style&index=1&id=117396d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117396d5"]])

export default __exports__